// src/App.tsx
import React from "react";
import Navbar from "./components/layout/Navbar";
import HeroSection from "./components/sections/HeroSection";
import LiteShowcaseSection from "./components/sections/LiteShowcaseSection";
import StatsSection from "./components/sections/StatsSection";
import SolutionsSection from "./components/sections/SolutionsSection";
import FeaturesSection from "./components/sections/FeaturesSection";
import PricingSection from "./components/sections/PricingSection";
import ContactSection from "./components/sections/ContactSection";
import Footer from "./components/layout/Footer";
import { useVisitorTracking } from "./lib/useVisitorTracking";

const App: React.FC = () => {
  // Track visitor on page load
  useVisitorTracking();

  return (
    <div className="min-h-screen w-full max-w-full overflow-x-hidden bg-slate-900 font-sans text-slate-900 selection:bg-primary/20 selection:text-primary">
      <Navbar />
      <main className="w-full max-w-full overflow-x-hidden">
        <HeroSection />
        <LiteShowcaseSection />
        <StatsSection />
        <SolutionsSection />
        <FeaturesSection />
        <PricingSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default App;
